import type { FC, ReactNode } from 'react'
import type { DealFiltersSortBy } from '../../provider/types'
import { useDealFiltersOpsDispatch } from '../../DealFiltersProvider'
import { RadioGroup } from '@headlessui/react'
import { classNames } from '@g4g/utils/src/react/class-names'
import { sortByLabels } from '../../provider/sort'

const SortOption: FC<{ value: DealFiltersSortBy; children?: ReactNode }> = ({
  value,
  children,
}) => (
  <RadioGroup.Option className="flex items-center justify-between py-2" value={value}>
    {({ checked }) => (
      <>
        <RadioGroup.Label
          as="span"
          className={classNames(checked ? 'text-white' : 'text-gray-400')}
        >
          {children}
        </RadioGroup.Label>
        <div
          className={classNames(
            checked ? 'border-white' : 'border-gray-400',
            'flex items-center justify-center w-6 h-6',
            'border-2 rounded-full'
          )}
        >
          {checked && <div className="flex w-3.5 h-3.5 bg-green-500 rounded-full"></div>}
        </div>
      </>
    )}
  </RadioGroup.Option>
)

const MobileSortOptions: FC<{ sortBy: DealFiltersSortBy }> = ({ sortBy }) => {
  const dispatch = useDealFiltersOpsDispatch()

  return (
    <RadioGroup
      className="flex flex-col space-y-4 text-white"
      value={sortBy}
      onChange={(option: DealFiltersSortBy) => dispatch({ type: 'update-sort', sortBy: option })}
    >
      <RadioGroup.Label className="sr-only">Select sort deals by</RadioGroup.Label>
      <SortOption value="featured">{sortByLabels['featured']}</SortOption>
      <SortOption value="price-low-high">{sortByLabels['price-low-high']}</SortOption>
      <SortOption value="price-high-low">{sortByLabels['price-high-low']}</SortOption>
    </RadioGroup>
  )
}

export default MobileSortOptions
